// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__3iEme","label":"Radio_label__2jyhk","checkMark":"Radio_checkMark__1VUM1","disabled":"Radio_disabled__cX1ZL"};